(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["voucher-generator"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const API_BASE = 'https://discovery-pack-voucher.replit.app';
    const form = document.getElementById('voucher-form');
    
    if (!form) return;
    
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const orderNumber = document.getElementById('orderNumber').value.trim();
      const email = document.getElementById('email').value.trim();
      const submitButton = document.getElementById('submit-button');
      const resultsSection = document.getElementById('results-section');
      const buttonContent = document.getElementById('button-content');
      const buttonLoading = document.getElementById('button-loading');
      
      // Clear previous states
      clearErrors();
      resultsSection.classList.remove('show');
      
      // Validation
      if (!validateForm(orderNumber, email)) return;
      
      // Start loading
      setLoadingState(true, submitButton, buttonContent, buttonLoading);
      
      try {
        const response = await fetch(`${API_BASE}/api/generate-vouchers`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ orderNumber, email })
        });
        
        const data = await response.json();
        
        // Stop loading
        setLoadingState(false, submitButton, buttonContent, buttonLoading);
        
        // Display results
        displayResults(data, resultsSection);
        
      } catch (error) {
        console.error('Error:', error);
        setLoadingState(false, submitButton, buttonContent, buttonLoading);
        displayError('Verbindung fehlgeschlagen. Bitte versuche es erneut.', resultsSection);
      }
    });
    
    function validateForm(orderNumber, email) {
      let isValid = true;
      
      if (!orderNumber) {
        showError('orderNumber-error', 'Bestellnummer eingeben');
        document.getElementById('orderNumber').classList.add('error');
        isValid = false;
      }
      
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showError('email-error', 'Gültige E-Mail-Adresse eingeben');
        document.getElementById('email').classList.add('error');
        isValid = false;
      }
      
      return isValid;
    }
    
    function showError(elementId, message) {
      const errorElement = document.getElementById(elementId);
      errorElement.textContent = message;
      errorElement.classList.add('show');
    }
    
    function clearErrors() {
      document.querySelectorAll('.error-container').forEach(el => {
        el.textContent = '';
        el.classList.remove('show');
      });
      document.querySelectorAll('.modern-input').forEach(el => {
        el.classList.remove('error');
      });
    }
    
    function setLoadingState(loading, submitButton, buttonContent, buttonLoading) {
      submitButton.disabled = loading;
      if (loading) {
        buttonContent.style.display = 'none';
        buttonLoading.style.display = 'flex';
      } else {
        buttonContent.style.display = 'flex';
        buttonLoading.style.display = 'none';
      }
    }
    
    function displayResults(data, resultsSection) {
      if (data.success) {
        const totalValue = data.vouchers.reduce((sum, v) => sum + v.value, 0);
        
        const html = `
          <div class="success-header">
            <div class="success-icon">✓</div>
            <h3 class="success-title">Perfekt!</h3>
            <p class="success-subtitle">${data.message}</p>
          </div>
          
          ${(data.newVouchersCount > 0 || data.existingVouchersCount > 0) ? `
            <div class="stats-grid">
              ${data.newVouchersCount > 0 ? `
                <div class="stat-item">
                  <div class="stat-number">${data.newVouchersCount}</div>
                  <div class="stat-label">Neue Gutscheine</div>
                </div>
              ` : ''}
              ${data.existingVouchersCount > 0 ? `
                <div class="stat-item">
                  <div class="stat-number">${data.existingVouchersCount}</div>
                  <div class="stat-label">Bereits vorhanden</div>
                </div>
              ` : ''}
              <div class="stat-item">
                <div class="stat-number">€${totalValue.toFixed(2)}</div>
                <div class="stat-label">Gesamtwert</div>
              </div>
            </div>
          ` : ''}
          
          ${data.vouchers && data.vouchers.length > 0 ? `
            <div class="vouchers-grid">
              ${data.vouchers.map((voucher, index) => {
                const isNew = index >= data.existingVouchersCount;
                const statusClass = isNew ? 'new' : 'existing';
                const statusText = isNew ? 'Neu' : 'Vorhanden';
                
                return `
                  <div class="voucher-card ${statusClass}">
                    <div class="voucher-header">
                      <div class="voucher-info">
                        <h3>${voucher.productTitle}</h3>
                        <div class="voucher-value">€${voucher.value}</div>
                      </div>
                      <div class="voucher-status ${statusClass}">${statusText}</div>
                    </div>
                    <div class="voucher-code-section">
                      <div class="code-label">Gutscheincode</div>
                      <div class="code-row">
                        <div class="voucher-code">${voucher.code}</div>
                        <button class="copy-button" onclick="copyCode('${voucher.code}', this)">
                          Kopieren
                        </button>
                      </div>
                    </div>
                  </div>
                `;
              }).join('')}
            </div>
          ` : ''}
        `;
        
        resultsSection.innerHTML = html;
      } else {
        displayError(data.error, resultsSection);
      }
      
      setTimeout(() => {
        resultsSection.classList.add('show');
        resultsSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }
    
    function displayError(message, resultsSection) {
      const html = `
        <div class="error-card">
          <div class="error-icon">⚠</div>
          <h3 class="error-title">Fehler aufgetreten</h3>
          <p class="error-message">${message}</p>
        </div>
      `;
      
      resultsSection.innerHTML = html;
      setTimeout(() => {
        resultsSection.classList.add('show');
        resultsSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }
  });
  
  // Global copy function
  window.copyCode = function(text, button) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        showCopyFeedback(button);
      }).catch(() => {
        fallbackCopy(text, button);
      });
    } else {
      fallbackCopy(text, button);
    }
  };
  
  function showCopyFeedback(button) {
    const originalText = button.textContent;
    button.textContent = 'Kopiert!';
    button.classList.add('copied');
    
    setTimeout(() => {
      button.textContent = originalText;
      button.classList.remove('copied');
    }, 2000);
  }
  
  function fallbackCopy(text, button) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      showCopyFeedback(button);
    } catch (err) {
      console.error('Copy failed', err);
    }
    
    document.body.removeChild(textArea);
  }
  } catch(e) { console.error(e); }
})();

})();
